import { render, staticRenderFns } from "./DataHistory.vue?vue&type=template&id=1591b696&"
import script from "./DataHistory.js?vue&type=script&lang=js&"
export * from "./DataHistory.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports